import { IconMarkerL } from 'icons/components/IconMarkerL'
import { IconMarkerS } from 'icons/components/IconMarkerS'
import { IconPinSelected } from 'icons/components/IconPinSelected'
import { IconPinUnselected } from 'icons/components/IconPinUnselected'
import { MAP_TYPE } from 'maps/types'

const SelectedMarkerStore = {
	component: <IconMarkerL width={40} height={57} />,
	zIndex: 1,
}
const UnselectedMarkerStore = {
	component: <IconMarkerS width={36} height={52} />,
	zIndex: 0,
}
const SelectedMarkerDroppoint = {
	component: <IconPinSelected width={40} height={57} />,
	zIndex: 1,
}
const UnselectedMarkerDroppoint = {
	component: <IconPinUnselected width={36} height={52} />,
	zIndex: 0,
}

const MARKERS = {
	[MAP_TYPE.STORES]: {
		SelectedMarker: SelectedMarkerStore,
		UnselectedMarker: UnselectedMarkerStore,
	},
	[MAP_TYPE.GARMENT_STORES]: {
		SelectedMarker: SelectedMarkerStore,
		UnselectedMarker: UnselectedMarkerStore,
	},
	[MAP_TYPE.DROPPOINTS]: {
		SelectedMarker: SelectedMarkerDroppoint,
		UnselectedMarker: UnselectedMarkerDroppoint,
	},
}

export function getMarkers(type?: MAP_TYPE) {
	return MARKERS[type ?? MAP_TYPE.STORES]
}
